import { useEnv } from '@zenbusiness/application-commons-env';

import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';

const useBankingPath = () => {
  const { businessEntityUuid } = useConstBusinessEntityUuid();

  const { PARENT_SEGMENT = '/d' } = useEnv();

  if (PARENT_SEGMENT === `/d`) {
    return `${PARENT_SEGMENT}/b/${businessEntityUuid}`;
  }

  return `${PARENT_SEGMENT}/${businessEntityUuid}/banking`;
};

export default useBankingPath;
